module.exports = __webpack_public_path__ + "static/media/full-screen-image-2.f7c47e22.jpg";